import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from '../../ducks/auth';
import { Container, Row, Col } from 'reactstrap';
import injectSheet from 'react-jss';

export class Footer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      signOut: PropTypes.func.isRequired
    }),
    isAuthorized: PropTypes.bool.isRequired,
    fullName: PropTypes.string.isRequired,
    rawInfo: PropTypes.objectOf(PropTypes.any).isRequired
  };

  componentDidMount() {
    const {
      actions: { getPetitions }
    } = this.props;
    this.interval = setInterval(() => getPetitions(), 15000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  signOut = () => {
    const { actions } = this.props;
    actions.signOut();
  };

  render() {
    const { classes } = this.props;
    return (
      <footer>
        <Container fluid className='p-3 border-top bg-white'>
          <Row>
            <Col md='10' className='order-2 order-md-1'>
              <p className='text-muted mt-3'>
                {new Date().getFullYear()} © Акционерное общество «Страховая компания «
                <a href='//ulife.ru' target='_blank' rel='noopener noreferrer'>
                  Ю-Лайф
                </a>
                », лицензии ЦБ РФ СЖ № 4014, СЛ № 4014 Российская Федерация, 121087, г. Москва,
                Береговой проезд, д. 5А, корпус 1, 20 этаж, офис 20/1/1{' '}
                <a href='//ulife.ru' target='_blank' rel='noopener noreferrer'>
                  ulife.ru
                </a>
              </p>
            </Col>
            <Col md='2' className='text-left text-md-right order-1 order-md-2 mb-4 mb-md-0'>
              <div className='h4'>
                <a href='tel:88007700700' className={classes.phone}>
                  8-800-770-07-00
                </a>
              </div>
              <div className='mr-3'>
                <a href='mailto:mail@ulife.ru'>mail@ulife.ru</a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  isAuthorized: auth.isAuthorized,
  fullName: auth.fullName,
  rawInfo: auth.rawInfo
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...AuthActions }, dispatch)
});

const styles = theme => ({
  phone: {
    color: theme.colors.main
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(Footer));
